/*!
  _   _  ___  ____  ___ ________  _   _   _   _ ___   
 | | | |/ _ \|  _ \|_ _|__  / _ \| \ | | | | | |_ _| 
 | |_| | | | | |_) || |  / / | | |  \| | | | | || | 
 |  _  | |_| |  _ < | | / /| |_| | |\  | | |_| || |
 |_| |_|\___/|_| \_\___/____\___/|_| \_|  \___/|___|
                                                                                                                                                                                                                                                                                                                                       
=========================================================
* Horizon UI - v1.1.0
=========================================================

* Product Page: https://www.horizon-ui.com/
* Copyright 2023 Horizon UI (https://www.horizon-ui.com/)

* Designed and Coded by Simmmple

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// Chakra imports
import { Box, SimpleGrid } from '@chakra-ui/react';
import IncidentTable from 'views/admin/incidentDetails/components/incidentSub/IncidentTable';
import { columnsDataComplex } from 'views/admin/incidentDetails/variables/columnsData';
import React, { useEffect, useState, useCallback } from 'react';
import IncidentService from '../../../services/IncidentService';

export default function Settings() {

  const [error, setError] = useState('');

  const [tableDataComplex, setVehicleData] = useState([]);

  const getIncidentData =  useCallback(async () => {
    try {
      const incidentData = await IncidentService.getAllIncidents(localStorage.getItem('token'));
      if (incidentData.status === 201 && incidentData.data.object) {

        let err = error;
          if(err){

          }

        const filteredData = incidentData.data.object.map(item => {
          let incidentLevel = '';

          if(item.incidentLevel === 'DO_NOT_OPERATE_MACHINERY'){
            incidentLevel = 'Do Not Operate Machinery';
          } else if(item.preStartCheckLevel === 'Report & Proceed with Caution'){
            incidentLevel = 'REPORT_AND_PROCEED_WITH_CAUTION';
          } else if(item.preStartCheckLevel === 'SUCCESS'){
            incidentLevel = 'Success';
          }

          return{
            id: item.id,
            rego: item.vehicle.registration,
            vinNumber: item.vehicle.vinNumber,
            model: item.vehicle.model,
            year: item.vehicle.year,
            category: item.vehicle.vehicleCategory.category,
            type: item.vehicle.vehicleType.type,
            driverName: item.user.preferredName,
            incidentLevel: incidentLevel,
            status: item.incidentStatus,
            options: ''
          };
      });
        setVehicleData(filteredData)
      } else {
        setError(incidentData.error);
      }
    } catch (error) {
      console.log(error);
      setError(error);
      setTimeout(() => {
        setError('');
      }, 5000);
    }
  }, [error]);

  // eslint-disable-next-line
  useEffect(() => {
    // eslint-disable-next-line
    getIncidentData()
   
  }, [getIncidentData]);

  

  // Chakra Color Mode
  return (
    <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
      <SimpleGrid
        mb="20px"
        columns={{ sm: 1 }}
        spacing={{ base: '20px', xl: '20px' }}
      >
         {tableDataComplex && tableDataComplex.length > 0 ? (
        <IncidentTable
          columnsData={columnsDataComplex}
          tableData={tableDataComplex}
        />
      ) : (
        <p>No Incidents available</p> // Optional: message when no data is available
      )}
      </SimpleGrid>
    </Box>
  );
}
